module.exports = __webpack_public_path__ + "img/icon-horn.1e86e36.png";